import Nullstack from 'nullstack';
export default function IconQrcodeOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-qrcode-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 4h1a1 1 0 0 1 1 1v1m-.297 3.711a0.997 .997 0 0 1 -.703 .289h-4a1 1 0 0 1 -1 -1v-4c0 -.275 .11 -.524 .29 -.705"
  }), "   ", Nullstack.element("path", {
    d: "M7 17v.01"
  }), "   ", Nullstack.element("rect", {
    x: "14",
    y: "4",
    width: "6",
    height: "6",
    rx: "1"
  }), "   ", Nullstack.element("path", {
    d: "M7 7v.01"
  }), "   ", Nullstack.element("rect", {
    x: "4",
    y: "14",
    width: "6",
    height: "6",
    rx: "1"
  }), "   ", Nullstack.element("path", {
    d: "M17 7v.01"
  }), "   ", Nullstack.element("path", {
    d: "M20 14v.01"
  }), "   ", Nullstack.element("path", {
    d: "M14 14v3"
  }), "   ", Nullstack.element("path", {
    d: "M14 20h3"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}